import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import IncidentStatus from '@components/incidentStatus/IncidentStatus'

import { EtatWorkflowIncidentEnum } from '@api/enum'

const data: EtatWorkflowIncidentEnum[] = [
  EtatWorkflowIncidentEnum.ABANDONNEE,
  EtatWorkflowIncidentEnum.CLOTUREE_PRESTATAIRE,
  EtatWorkflowIncidentEnum.DEVIS_ENVOYE,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_DEVIS,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_PRISE_EN_CHARGE,
  EtatWorkflowIncidentEnum.EN_PAUSE,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_VALIDATION,
  EtatWorkflowIncidentEnum.EN_COURS_DE_TRAITEMENT,
  EtatWorkflowIncidentEnum.CLOTUREE_VIPARIS,
  EtatWorkflowIncidentEnum.REFUS_PRESTATAIRE,
]

const IncidentStatusesSection = () => {
  const renderStatus = (status: EtatWorkflowIncidentEnum) => (
    <Container key={status}>
      <IncidentStatus incidentStatus={status} />
    </Container>
  )

  return (
    <Section>
      <SectionTitle>Incident States</SectionTitle>
      <SubTitle>Default</SubTitle>
      {data.map(renderStatus)}

      <SubTitle>Large</SubTitle>
      <Container>
        <IncidentStatus size="large" incidentStatus={data[0]} />
      </Container>
    </Section>
  )
}

export default IncidentStatusesSection

const Section = styled(View)`
  padding: 24px;
  border-color: ${(props) => props.theme.colors.disable};
  border-bottom-width: 1px;
  border-style: solid;
`
const SectionTitle = styled(Text)`
  margin-bottom: 15px;
  text-decoration: underline;
  ${(props) => props.theme.fonts.LargeTitle};
`
const SubTitle = styled(Text)`
  margin: 15px 0;
  text-decoration: underline;
  ${(props) => props.theme.fonts.Callout};
`
const Container = styled(View)`
  margin: 8px 0;
`
